var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.5C1.55 10.5 1.375 10.425 1.225 10.275C1.075 10.125 1 9.95 1 9.75V3.75C1 3.55 1.075 3.375 1.225 3.225C1.375 3.075 1.55 3 1.75 3H4V1.75C4 1.55 4.075 1.375 4.225 1.225C4.375 1.075 4.55 1 4.75 1H7.25C7.45 1 7.625 1.075 7.775 1.225C7.925 1.375 8 1.55 8 1.75V3H10.25C10.45 3 10.625 3.075 10.775 3.225C10.925 3.375 11 3.55 11 3.75V9.75C11 9.95 10.925 10.125 10.775 10.275C10.625 10.425 10.45 10.5 10.25 10.5H1.75ZM1.75 9.75H10.25V3.75H1.75V9.75ZM4.75 3H7.25V1.75H4.75V3Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.b0fc8eebd22753eac993a6c633d3d8f3.svg";
export { ForwardRef as ReactComponent };